import {useContext, useState, useRef, useEffect} from 'react';
import {UserContext} from '../../contexts/UserContext';
import {ChatContext} from '../../contexts/ChatContext';
import {RecipientFetcher} from '../../hooks/recipientFetcher';
import {Stack, Spinner, Form} from 'react-bootstrap';
import moment from 'moment';
import InputEmoji from 'react-input-emoji';
import Icon from '@mdi/react';
import {mdiSendVariant} from '@mdi/js';

export const ChatBox = ({chat}) => {
	const {user} = useContext(UserContext);
	const { messages, isMessagesLoading, sendTextMessage} = useContext(ChatContext);
	const {recipientUser} = RecipientFetcher(chat, user);
	const [textMessage, setTextMessage] = useState('');
	const scroll = useRef();

	useEffect(() => {
		scroll.current?.scrollIntoView({behavior: 'smooth'})
	}, [messages])

	if(!chat){
		return <div style={{textAlign: 'center', width: '100%'}}>No selected conversation...</div>
	}
	if(isMessagesLoading){
		return (
			<div style={{textAlign: 'center', width: '100%'}}>      
				<Spinner animation="border" variant="primary" />
		    </div>
		)
	}
	return(
		<Stack style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
			<div className="chat-header">
				<strong>{recipientUser?.name}</strong>
			</div>
			<Stack gap={3} className="messages">
				{messages && messages.map((message, index) => 
					<Stack key={index} className={`${message?.senderId === user?._id ? 'message self align-self-end flex-grow-0' : 'message align-self-start flex-grow-0'}`} ref = {scroll}>
						<span className="mb-3" style={{wordWrap: 'break-word'}}>{message.text}</span>
						<span className="message-footer">{moment(message.createdAt).calendar()}</span>
					</Stack>
				)}
			</Stack>
			<Stack direction="horizontal" gap={3} className="chat-input flex-grow-0" >
				<div style={{ width: 'calc(100% - 4rem)', flexGrow: 0 }}>
					<InputEmoji value={textMessage} onChange={setTextMessage} fontFamily="nunito" borderColor="rgba(72, 112, 223, 0.2" style={{ width: '100%', wordWrap: 'break-word' }}/>
				</div>
				<button className="send-btn" onClick={() => sendTextMessage(textMessage, user, chat._id, setTextMessage)}>
					<Icon path={mdiSendVariant} size={1} />
				</button>
			</Stack>
		</Stack>
	)
}

